import { Link } from "react-router-dom";
import CountUp from "@/components/feature/CountUp";
import { heroStats } from "@/mocks/stats";

export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/7cb346ee-08b8-4aed-8389-778a643bccf0/3b8ac2a1-8b4b-4096-9e6d-28981b8ff3e0_compressed_IMG_3403.webp"
          alt="Proyecto residencial de Inmobiliaria ADJ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-32 pb-20 flex flex-col items-center text-center">
        <div className="max-w-4xl flex flex-col items-center gap-6">
          <span className="text-xs md:text-sm font-semibold uppercase tracking-[0.35em] text-background-100/80">
            Inmobiliaria ADJ SpA
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl leading-[1.05] text-background-50">
            Construimos espacios para vivir, invertir y crecer.
          </h1>
          <p className="max-w-2xl text-base md:text-xl text-background-100/90 leading-relaxed">
            Inmobiliaria ADJ desarrolla proyectos residenciales que combinan diseño, seguridad,
            calidad e innovación.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
            <Link
              to="/proyectos"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md bg-yellow-400 hover:bg-yellow-300 text-foreground-950 text-sm md:text-base font-semibold px-8 py-3.5 transition-colors duration-300 whitespace-nowrap"
            >
              VER PROYECTOS
            </Link>
            <Link
              to="/nosotros"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-md border border-background-50/60 hover:bg-background-50 hover:text-foreground-900 text-background-50 text-sm md:text-base font-semibold px-8 py-3.5 transition-colors duration-300 whitespace-nowrap"
            >
              CONÓCENOS
            </Link>
          </div>
        </div>

        <div className="w-full max-w-5xl mt-16 md:mt-24">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 border-t border-background-50/20 pt-8">
            {heroStats.map((stat) => (
              <div key={stat.id} className="flex flex-col items-center gap-1.5">
                {stat.id === "region" ? (
                  <span className="font-heading text-3xl md:text-4xl font-semibold text-background-50">
                    Región Metropolitana
                  </span>
                ) : (
                  <span className="font-heading text-3xl md:text-5xl font-semibold text-background-50">
                    <CountUp value={stat.value} suffix={stat.suffix} />
                  </span>
                )}
                <span className="text-xs md:text-sm text-background-100/70">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}